import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

export const HeadSkeleton = () => {
  return (
    <Box className={styles['head-skeleton__container']}>
      <Box className={styles['head-skeleton__title']}>
        <SkeletonComponent height="34px" width="150px" />
      </Box>
      <Box className={styles['head-skeleton__action--wrapper']}>
        <SkeletonComponent height="34px" width="24px" />
        <SkeletonComponent height="34px" width="24px" />
        <SkeletonComponent height="34px" width="168px" />
      </Box>
    </Box>
  );
};

export const TabSkeleton = () => {
  return <Flex className={styles['tabk-skeleton__container']} justifyContent={'space-between'}>
    <Flex gap={"20px"}>
      <SkeletonComponent height="34px" width="80px" />
      <SkeletonComponent height="34px" width="100px" />
    </Flex>
    <SkeletonComponent height="34px" width="100px" />
  </Flex>;
};

export const TableSkeleton = () => {
  return (
    <Box data-testid="table-report-attendance-operator-detail__skeleton">
      <Table>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} minWidth="150px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="154px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="163px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="220px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};
